import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Element } from '@svgdotjs/svg.js';
import {
  SynopticElementState,
  SynopticElementStatic
} from '../../../../../model/synoptics/synoptic-configuration-types';
import { cloneDeep } from 'lodash';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-synoptics-form-static',
  templateUrl: './synoptics-form-static.component.html',
  styleUrls: ['./synoptics-form-static.component.scss']
})
export class SynopticsFormStaticComponent implements OnInit {

  @Input() statics: SynopticElementStatic[];
  @Input() selection: Element;
  @Output() changeSelectionById: EventEmitter<string>;
  @Output() staticsChange: EventEmitter<SynopticElementStatic[]>;

  public attributeOptions: SelectItem[];

  constructor() {
    this.staticsChange = new EventEmitter<SynopticElementStatic[]>();
    this.changeSelectionById = new EventEmitter<string>();
    this.attributeOptions = [
      { label: 'common.text', value: 'text' }
    ]
  }

  ngOnInit(): void {
  }

  addNewStatic() {
    const staticReplacement = this.generateDefaultStatic(this.selection.id());
    this.statics = [...this.statics, staticReplacement];
    this.onStaticsChange();
  }

  public duplicateStatic(staticReplacement: SynopticElementStatic): void {
    const duplicated = cloneDeep(staticReplacement);
    duplicated.id = this.selection?.id() ?? duplicated.id;
    this.statics.push(duplicated);
    this.onStaticsChange();
  }

  public removeStatic(staticReplacement: SynopticElementStatic): void {
    this.statics = this.statics.filter(s => s != staticReplacement);
    this.onStaticsChange();
  }

  public onStaticsChange(): void {
    this.staticsChange.emit(this.statics);
  }

  private generateDefaultStatic(elementId: string): SynopticElementStatic {
    return { id: elementId, attribute: 'text', value: '' };
  }

}
